import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from '../notifier';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import api from '../../api/backend'

import CloseIcon from '@material-ui/icons/Close';

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        paddingTop: 84,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    submit: {
        marginTop: 20
    }
});

class EditProfile extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {}, userName: '', firstName: '', lastName: '', nickName: '',
            confirmPassword: '', newPassword: '',
            tel: '', email: '', password: undefined, address: '', role: '', show: false, loading: false
        }
    }

    close = () => {
        this.setState({ show: false, loading: false })
        if (this.props.onClickProfile) {
            this.props.onClickProfile()
        }
    }

    updateUser = (event) => {
        event.preventDefault();
        const { user, userName, firstName, lastName, nickName, tel, email, confirmPassword, newPassword, address, role } = this.state
        const { onUpdated } = this.props
        let password = undefined
        if (newPassword !== undefined && newPassword !== '' && newPassword !== confirmPassword) {
            console.error('รหัสผ่านใหม่ และยื่นยันรหัสผ่านใหม่ ไม่ถูกต้องโปรดตรวจสอบ')
            openSnackbar({ message: 'รหัสผ่านใหม่ และยื่นยันรหัสผ่านใหม่ ไม่ถูกต้องโปรดตรวจสอบ' })
            return
        } else if (newPassword !== undefined && newPassword !== '' && newPassword === confirmPassword && newPassword.length < 4) {
            openSnackbar({ message: 'รหัสผ่านใหม่ต้องมีความยาวมากกว่า 4 ตัวอักษร' })
            return
        } else if (newPassword !== undefined && newPassword !== '' && newPassword === confirmPassword && newPassword.length >= 4) {
            password = newPassword
        }
        this.setState({ loading: true })

        api.updateUser(user.id, { userName, firstName, lastName, nickName, tel, email, password, address, role }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({
                    firstName: json.firstName, lastName: json.lastName, nickName: json.nickName,
                    confirmPassword: '', newPassword: '',
                    tel: json.tel, email: json.email, password: json.password, address: json.address, role: json.role
                })
                openSnackbar({ message: 'บันทึกสำเร็จ' })
                if (onUpdated) {
                    onUpdated()
                }
                setTimeout(() => {
                    this.close()
                }, 3000);
            } else {
                console.error('ไม่สามารถบันทึกได้')
                openSnackbar({ message: 'ไม่สามารถบันทึกได้' })
                this.setState({ loading: false });
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
            this.setState({ loading: false });
        })
    }

    getProfile = () => {
        const { user } = this.props
        api.getUser(user.userName).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({
                    user: json, userName: json.userName,
                    firstName: json.firstName, lastName: json.lastName, nickName: json.nickName,
                    confirmPassword: '', newPassword: '',
                    tel: json.tel, email: json.email, address: json.address, role: json.role, show: false, loading: false
                })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    componentDidMount() {
        this.getProfile()
    }

    render() {
        const { classes } = this.props
        const { userName, firstName, lastName, nickName, tel, email, confirmPassword, newPassword, address, role, loading } = this.state
        return (
            <React.Fragment>
                <MenuItem onClick={() => {
                    this.setState({ show: true })
                }}>แก้ไขโปรไฟล์</MenuItem>

                <Dialog
                    open={this.state.show}
                    onClose={this.close}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">แก้ไขผู้ใช้งาน</DialogTitle>
                    <DialogContent>
                        <Notifier />
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="userName"
                                    name="userName"
                                    label="ชื่อเข้าใช้ระบบ"
                                    fullWidth
                                    autoComplete="user userName"
                                    value={userName}
                                    disabled={true}
                                    onChange={(event) => { this.setState({ userName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="email"
                                    name="email"
                                    label="อีเมลล์"
                                    fullWidth
                                    autoComplete="user email"
                                    value={email}
                                    onChange={(event) => { this.setState({ email: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    type="password"
                                    id="newPassword"
                                    name="newPassword"
                                    label="พาสเวิร์ดใหม่"
                                    fullWidth
                                    autoComplete="user password"
                                    value={newPassword}
                                    onChange={(event) => { this.setState({ newPassword: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    type="password"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    label="ยืนยันพาสเวิร์ดใหม่"
                                    fullWidth
                                    autoComplete="user password"
                                    value={confirmPassword}
                                    onChange={(event) => { this.setState({ confirmPassword: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="firstName"
                                    name="firstName"
                                    label="ชื่อ"
                                    fullWidth
                                    autoComplete="user firstName"
                                    value={firstName}
                                    onChange={(event) => { this.setState({ firstName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="lastName"
                                    name="lastName"
                                    label="นามสกุล"
                                    fullWidth
                                    autoComplete="user lastName"
                                    value={lastName}
                                    onChange={(event) => { this.setState({ lastName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    required
                                    id="nickName"
                                    name="nickName"
                                    label="ชื่อเล่น"
                                    fullWidth
                                    autoComplete="user nickName"
                                    value={nickName}
                                    onChange={(event) => { this.setState({ nickName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="tel"
                                    name="tel"
                                    label="เบอร์โทรศัพท์"
                                    fullWidth
                                    autoComplete="user tel"
                                    value={tel}
                                    onChange={(event) => { this.setState({ tel: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} required disabled>
                                    <InputLabel htmlFor="role-helper">ประเภทผู้ใช้งาน</InputLabel>
                                    <Select
                                        value={role}
                                        onChange={(event) => { this.setState({ role: event.target.value }) }}
                                        input={<Input name="role" id="role-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Student">นักเรียน</MenuItem>
                                        <MenuItem value="Instructor">ผู้สอน</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกประเภทผู้ใช้งาน นักเรียน หรือผู้สอน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="address"
                                    name="address"
                                    label="ที่อยู่"
                                    fullWidth
                                    multiline
                                    rows={5}
                                    autoComplete="course address"
                                    value={address}

                                    onChange={(event) => { this.setState({ address: event.target.value }) }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.close} color="default" disabled={loading}>
                            ยกเลิก
                        </Button>
                        <Button onClick={this.updateUser} color="primary" disabled={loading}>
                            บันทึก
                        </Button>
                        {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : <React.Fragment>
                        </React.Fragment>}
                    </DialogActions>
                </Dialog>

                {/* <Drawer anchor="right" open={this.state.show} classes={{
                    paper: classes.drawer,
                }} onClose={this.close}>
                    <Notifier />
                    <Card className={classes.card}>
                        <CardHeader
                            title={<Typography variant="title" gutterBottom>
                                แก้ไขผู้ใช้งาน
                            </Typography>} />
                        <CardContent className={classes.cardContent}>
                            <form className={classes.form} onSubmit={this.updateUser}>
                                <Grid container spacing={24}>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="userName"
                                            name="userName"
                                            label="ชื่อเข้าใช้ระบบ"
                                            fullWidth
                                            autoComplete="user userName"
                                            value={userName}
                                            disabled={true}
                                            onChange={(event) => { this.setState({ userName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="email"
                                            name="email"
                                            label="อีเมลล์"
                                            fullWidth
                                            autoComplete="user email"
                                            value={email}
                                            onChange={(event) => { this.setState({ email: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            type="password"
                                            id="newPassword"
                                            name="newPassword"
                                            label="พาสเวิร์ดใหม่"
                                            fullWidth
                                            autoComplete="user password"
                                            value={newPassword}
                                            onChange={(event) => { this.setState({ newPassword: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            type="password"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            label="ยืนยันพาสเวิร์ดใหม่"
                                            fullWidth
                                            autoComplete="user password"
                                            value={confirmPassword}
                                            onChange={(event) => { this.setState({ confirmPassword: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="firstName"
                                            name="firstName"
                                            label="ชื่อ"
                                            fullWidth
                                            autoComplete="user firstName"
                                            value={firstName}
                                            onChange={(event) => { this.setState({ firstName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="lastName"
                                            name="lastName"
                                            label="นามสกุล"
                                            fullWidth
                                            autoComplete="user lastName"
                                            value={lastName}
                                            onChange={(event) => { this.setState({ lastName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="nickName"
                                            name="nickName"
                                            label="ชื่อเล่น"
                                            fullWidth
                                            autoComplete="user nickName"
                                            value={nickName}
                                            onChange={(event) => { this.setState({ nickName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="tel"
                                            name="tel"
                                            label="เบอร์โทรศัพท์"
                                            fullWidth
                                            autoComplete="user tel"
                                            value={tel}
                                            onChange={(event) => { this.setState({ tel: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="address"
                                            name="address"
                                            label="ที่อยู่"
                                            fullWidth
                                            multiline
                                            rows={5}
                                            autoComplete="course address"
                                            value={address}
                                            onChange={(event) => { this.setState({ address: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} required disabled>
                                            <InputLabel htmlFor="role-helper">ประเภทผู้ใช้งาน</InputLabel>
                                            <Select
                                                value={role}
                                                onChange={(event) => { this.setState({ role: event.target.value }) }}
                                                input={<Input name="role" id="role-helper" required />}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="Student">นักเรียน</MenuItem>
                                                <MenuItem value="Instructor">ผู้สอน</MenuItem>
                                            </Select>
                                            <FormHelperText>เลือกประเภทผู้ใช้งาน นักเรียน หรือผู้สอน</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <div className={classes.wrapper}>
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        disabled={loading}
                                        className={classes.submit}
                                        size="large"
                                        fullWidth
                                    >
                                        บันทึก
                                    </Button>
                                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                </Drawer> */}
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(EditProfile);